import { Box, HStack } from '@chakra-ui/react'
import { type TopNavPanelItem } from 'ecosystem'
import { GrandLink, useUIIcon } from 'ui/common'

interface MobileMenuTopNavPanelItemProps {
  panelItem: TopNavPanelItem
}

export const MobileMenuTopNavPanelItem = ({ panelItem }: MobileMenuTopNavPanelItemProps) => {
  const Icon = useUIIcon(panelItem.icon)

  const renderContent = () => (
    <HStack
      justify="flex-start"
      gap={4}
      py={4}
      px={6}
      fontSize="md"
      {...(!panelItem.href && {
        color: 'text.mild'
      })}
    >
      <Icon />
      <Box textAlign="center">{panelItem.label}</Box>
    </HStack>
  )

  if (panelItem?.href) {
    return (
      <GrandLink href={panelItem.href} userSelect="none">
        {renderContent()}
      </GrandLink>
    )
  }

  return <>{renderContent()}</>
}
